/**
 * 企业上下文
 *
 * 当前企业以地址栏的 company_id 为权威来源：所有请求的 x-enterprise-id 都取自它，
 * 切换企业 = 改写 company_id 后整页刷新。URL 上没有时才回落到服务端返回的默认企业。
 */

export const ENTERPRISE_QUERY_KEY = 'company_id';

/** 从地址栏读取当前企业 id，缺失或非法时返回 null */
export const getEnterpriseIdFromUrl = (): number | null => {
  const raw = new URLSearchParams(window.location.search).get(ENTERPRISE_QUERY_KEY);
  if (!raw) {
    return null;
  }
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
};

/**
 * 给外部应用（认证中心等）的地址拼上 company_id，保证对方落在同一个企业
 */
export const withEnterpriseId = (targetUrl: string, enterpriseId: number | null): string => {
  if (!targetUrl || enterpriseId == null) {
    return targetUrl;
  }
  try {
    const url = new URL(targetUrl, window.location.origin);
    url.searchParams.set(ENTERPRISE_QUERY_KEY, String(enterpriseId));
    return url.toString();
  } catch {
    // 目标地址非法时原样返回，不因为拼参数把跳转弄挂
    return targetUrl;
  }
};

/**
 * 切换企业后的落地地址：回根路径，由路由守卫按新企业的角色决定首个可访问页面
 * （不保留原页面路径，因为换企业后角色可能变化、原页面未必还有权限）
 */
export const buildEnterpriseSwitchUrl = (enterpriseId: number): string => {
  const url = new URL(window.location.origin);
  url.pathname = '/';
  url.searchParams.set(ENTERPRISE_QUERY_KEY, String(enterpriseId));
  return url.toString();
};
